import { ObjectValues } from 'src/common/tsHelpers';

export const SIM_INVENOTRY_PERMISSIONS = {
  ViewSimListAndDetails: 'viewSimList',
  ViewSimDetails: 'viewSimDetails',
  ViewTags: 'viewTags',
  EditTags: 'editTags',
  Export: 'export',
  ExportPoolingLogs: 'exportPoolingLogs',
  SimulateOutage: 'simulateOutage',
  RestoreOTAConfiguration: 'restoreOtaConfiguration',
  ViewOtaConfigurationsDetails: 'viewOtaConfigurationsDetails',
  BulkProvisioning: 'bulkProvisioning',
  ViewCustomFields: 'viewCustomFields',
  HasInternalDataAccess: 'hasInternalDataAccess',
  ViewRsim: 'viewRsim',
  EditCustomFields: 'editCustomFields',
  ImportRsims: 'importRsims',
  RSimProductProvisioning: 'rsimProductProvisioning',
  SimProductProvisioning: 'simProductProvisioning',
  AggregatedUsageView: 'aggregatedUsageView',
  InLifeActivation: 'inLifeActivation',
  InLifeSuspension: 'inLifeSuspension',
  InLifeUnsuspension: 'inLifeUnsuspension',
  InLifeTermination: 'inLifeTermination',
  InLifeCancelLocation: 'inLifeCancelLocation',
  SubscriptionStatusReconciliation: 'subscriptionStatusReconciliation',
} as const;

export type SimInventoryPermissions = ObjectValues<typeof SIM_INVENOTRY_PERMISSIONS>;

export const BULK_PROVISIONING_PERMISSIONS = {
  DownloadReport: 'downloadReport',
  ViewTableAndDetails: 'viewTableAndDetails',
  UploadFile: 'uploadFile',
  SetSimStatus: 'setSimStatus',
  ProductManagementView: 'productManagementView',
} as const;

export type BulkProvisioningPermissions = ObjectValues<typeof BULK_PROVISIONING_PERMISSIONS>;

export const AUDIT_TRAILS_PERMISSIONS = {
  viewAuditTrailList: 'viewAuditTrailList',
  export: 'export',
} as const;

export type AuditTrailsPermissions = ObjectValues<typeof AUDIT_TRAILS_PERMISSIONS>;
